import { render } from "./SwiperNav.vue?vue&type=template&id=7ce831ea"
import script from "./SwiperNav.vue?vue&type=script&lang=js"
export * from "./SwiperNav.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__